<div class="catalog">
  <header class="catalog-header">
    <mat-icon class="catalog-icon">add_chart</mat-icon>
    <h2>{{ 'catalog.title' | translate }}</h2>

    <app-search-bar class="catalog-search" [value]="search()" [width]="320"
      (searchText)="search.set($event)"></app-search-bar>

    <lib-button color="none" textColor="muted" icon="close" class="catalog-close" (click)="close()">
    </lib-button>
  </header>

  <div class="catalog-body">
    <nav class="catalog-nav">
      <button type="button" class="nav-item types-view" [class.active]="view() === 'types'"
        (click)="selectView('types')">
        <mat-icon>widgets</mat-icon>
        <span class="nav-label">{{ 'catalog.types' | translate }}</span>
        <span class="nav-count">{{ graphTypes.length }}</span>
      </button>

      <!-- Its families, always shown -->
      @for (entry of families; track entry.family.key) {
      <button type="button" class="nav-item family-item" [class.active]="view() === entry.family.key"
        (click)="selectView(entry.family.key)">
        <mat-icon>{{ entry.family.icon }}</mat-icon>
        <span class="nav-label">{{ entry.family.name | translate }}</span>
        <span class="nav-count">{{ entry.types.length }}</span>
      </button>
      }

      <span class="nav-separator"></span>

      <button type="button" class="nav-item all-view" [class.active]="view() === 'all'" (click)="selectView('all')">
        <mat-icon>dashboard_customize</mat-icon>
        <span class="nav-label">{{ 'catalog.all' | translate }}</span>
      </button>

      @if (sections().length) {
      @for (section of sections(); track section.theme) {
      <button type="button" class="nav-item family-item theme-item" [class.active]="view() === section.theme"
        (click)="selectView(section.theme)">
        <mat-icon>{{ themeIcon(section.theme) }}</mat-icon>
        <span class="nav-label">{{ themeLabel(section.theme) | translate }}</span>
        <span class="nav-count">{{ section.templates.length }}</span>
      </button>
      }
      }
    </nav>

    <section class="catalog-content">
      @if (typesView()) {
      <!-- A type: its preview; a click opens the blank editor -->
      <div class="catalog-grid">
        @for (graphType of types(); track graphType.value) {
        <button type="button" class="template-card type-card" (click)="chooseType(graphType)">
          <app-widget-thumbnail [type]="graphType.type" [graphType]="graphType.value"
            [byProject]="scoped && byProjectType(graphType.type)">
          </app-widget-thumbnail>

          <span class="card-title">
            <mat-icon>{{ graphType.icon }}</mat-icon>
            {{ graphType.name | translate }}
          </span>
        </button>
        } @empty {
        <lib-no-data class="catalog-empty" icon="search_off" message="catalog.empty_types"
          description="form.search_no_data_desc">
        </lib-no-data>
        }
      </div>
      } @else if (loading()) {
      <app-spinner></app-spinner>
      } @else {
      <div class="catalog-grid">
        @for (template of visibleTemplates(); track template.id) {
        <div class="card-wrapper">
          <button type="button" class="template-card" [class.selected]="selected()?.id === template.id"
            (click)="select(template)">
            <app-widget-thumbnail [type]="template.type" [graphType]="template.graphType"
              [forecast]="forecast(template)" [byProject]="byProject(template)" [trend]="!!template.query?.compare">
            </app-widget-thumbnail>

            <span class="card-title">{{ title(template) }}</span>

            @if (template.description) {
            <span class="card-description" [title]="template.description">{{ template.description }}</span>
            }

            <span class="card-pills">
              @if (forecast(template)) {
              <span class="pill forecast-pill">{{ 'catalog.forecast' | translate }}</span>
              }

              @if (byProject(template)) {
              <span class="pill by-project-pill">{{ 'catalog.by_project' | translate }}</span>
              }
            </span>
          </button>

          @if (canManageTemplates) {
          <lib-button class="card-menu" color="none" textColor="muted" icon="more_vert"
            [matMenuTriggerFor]="templateMenu">
          </lib-button>

          <mat-menu #templateMenu="matMenu">
            <button mat-menu-item class="edit-template-info" (click)="editTemplateInfo(template)">
              <mat-icon>edit_note</mat-icon>
              <span>{{ 'catalog.edit_template_info' | translate }}</span>
            </button>

            <button mat-menu-item class="edit-template" (click)="editTemplate(template)">
              <mat-icon>tune</mat-icon>
              <span>{{ 'catalog.edit_template_widget' | translate }}</span>
            </button>

            <button mat-menu-item class="delete-template" (click)="deleteTemplate(template)">
              <mat-icon>delete</mat-icon>
              <span>{{ 'form.delete' | translate }}</span>
            </button>
          </mat-menu>
          }
        </div>
        } @empty {
        <lib-no-data class="catalog-empty" icon="dashboard_customize" message="catalog.empty">
        </lib-no-data>
        }
      </div>
      }
    </section>
  </div>

  @if (!typesView()) {
  <footer class="catalog-footer">
    <span class="catalog-hint">{{ 'catalog.hint' | translate }}</span>

    <lib-button class="customize-button" color="secondary" icon="tune" [text]="'catalog.customize' | translate"
      [disabled]="!selected() || saving()" (click)="customize()">
    </lib-button>

    <lib-button class="add-button" icon="add" [text]="'catalog.add' | translate" [loading]="saving()"
      [disabled]="!selected() || saving()" (click)="add()">
    </lib-button>
  </footer>
  }
</div>